module.exports = __webpack_public_path__ + "static/media/Playagaintxt.3813d183.png";